export const fileControl = /* GraphQL */ `
  query FileControl(
    $space_id: ID
    $action: String!
    $file_name: String
    $file_content: String
    $content_type: String
    $file_path: String
  ) {
    fileControl(
      space_id: $space_id
      action: $action
      file_name: $file_name
      file_content: $file_content
      content_type: $content_type
      file_path: $file_path
    )
  }
`

export const getPartner = /* GraphQL */ `
  query GetPartner($id: ID!) {
    getPartner(id: $id) {
      id
      name
      display_name
      logo
      app_settings {
        components
        application_input_additional_fields
      }
    }
  }
`

export const getCareer = /* GraphQL */ `
  query GetCareer($id: ID!) {
    getCareer(id: $id) {
      id
      title
      partner_id
      status
      language
      archived
      logo
      app_settings {
        components
        application_input_additional_fields
      }
    }
  }
`

export const inviteTalent = /* GraphQL */ `
  query InviteTalent(
    $send_mail: Boolean
    $ref_link: String
    $referrer_link: String
    $career_id: ID
    $partner_id: ID
    $partner_user_id: ID
    $firstname: String
    $lastname: String
    $email: String
    $phone: String
    $postcode: String
    $additional_requested_data: AWSJSON
    $id: ID
  ) {
    inviteTalent(
      send_mail: $send_mail
      ref_link: $ref_link
      referrer_link: $referrer_link
      career_id: $career_id
      partner_id: $partner_id
      partner_user_id: $partner_user_id
      firstname: $firstname
      lastname: $lastname
      email: $email
      phone: $phone
      postcode: $postcode
      additional_requested_data: $additional_requested_data
      id: $id
    ) {
      id
      language
    }
  }
`

export const getReachRequest = /* GraphQL */ `
  query GetReachRequest($id: ID!) {
    getReachRequest(id: $id) {
      id
      campaign_id
    }
  }
`

export const getReachCampaign = /* GraphQL */ `
  query GetReachCampaign($id: ID!) {
    getReachCampaign(id: $id) {
      id
      external_url
      mail_campaign_link_clicked_count
    }
  }
`
